<template>
  <collapse title="Análisis y verificación de costo">
    <validation-provider
      v-if="!isReadOnly"
      v-slot="{ errors }"
      :custom-messages="{
        required: 'El campo es requerido.',
      }"
      rules="required"
    >
      <custom-text-area
        v-model="model.costAnalysis"
        :count-classes="['d-block', 'small-counter']"
        :custom-error-msg="errors[0]"
        :error="errors[0]"
        label="Análisis y resultado que justifique la razonabilidad del costo de conformidad a lo establecido en el Manual para la negociación de servicios profesionales adquiridos mediante fondos administrados por la Secretaría Auxiliar de Asuntos Federales."
        :maxlength="10000"
        show-char-count
      />
    </validation-provider>
    <div v-else-if="isReadOnly" class="my-2 data-label">
      <label class="data-label">
        Análisis y resultado que justifique la razonabilidad del costo de
        conformidad a lo establecido en el Manual para la negociación de
        servicios profesionales adquiridos mediante fondos administrados por la
        Secretaría Auxiliar de Asuntos Federales.
      </label>
      {{ model.costAnalysis | empty }}
    </div>
  </collapse>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import Collapse from '@/components/common/SimpleCollapse.vue';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'CostAnalysis',
  components: {
    Collapse,
    ValidationProvider,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style scoped></style>
